import serviceClient from '../../service-client/service-client';

const copyFromCdn = async (iconSrc) => {
  const regex = /\/cdn\/(.+)/g;
  const match = regex.exec(iconSrc);
  if (!match) return null;
  const [, cdnKey] = match;

  const data = {
    cdnKey,
  };
  const client = serviceClient.get();
  const {
    data: { source },
  } = await client.copyFromCdn(data);

  return source;
};

export default copyFromCdn;
